import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";

export default function HomeIntro() {
  const navigate = useNavigate();

  return (
    <section className="home-intro">
      <motion.div
        className="home-intro-inner"
        initial={{ opacity: 0, y: 35 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7 }}
        viewport={{ once: true }}
      >
        {/* WELCOME TYPE INDICATOR */}
        <span className="intro-welcome ">ABOUT GULMOHAR PULSES</span>

        {/* MAIN LINE */}
        <h2 className="section-heading">A Trusted Name in Pulses Processing & Packaging</h2>

        {/* ABOUT SNAPSHOT */}
        <p>
          Gulmohar Pulses, operated by{" "}
          <strong>Rajbharti Quartzite Industries Pvt. Ltd.</strong>,
          is engaged in professional processing and bulk packaging of
          premium quality pulses. Established in 2016, we focus on
          sourcing directly from farmers, applying modern processing
          techniques, and delivering hygienically packed pulses
          for wholesale and trade markets.
        </p>

        {/* CTA */}
        <motion.button
          className="intro-btn"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.96 }}
          onClick={() => navigate("/about")}
        >
          READ MORE
        </motion.button>
      </motion.div>
    </section>
  );
}
